import { LOADING } from "../../constants/constant";
import {
  GENERATE_OTP,
  GENERATE_OTP_SUCCESS,
  GENERATE_OTP_FAILED,
  GENERATE_OTP_RESET
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function generateOtpReducer(state = initialState, action) {
  switch (action.type) {
    case GENERATE_OTP:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GENERATE_OTP_SUCCESS:
      let userRes = Object.assign({}, state);
      console.log("Otp generated", action);
      try {
        userRes.status = action.data.status
        userRes.message = action.data.message;
        userRes.isLoading = false;
        return userRes;
      } catch (error) {
        throw new Error(error);
      }

    case GENERATE_OTP_FAILED:
      return Object.assign({}, state, action.error);

    case GENERATE_OTP_RESET:
      return initialState;

    default:
      return state;
  }
}